import React from 'react';

import { Image } from '@af/design-system-docs-ui';
import { Box, Inline, Stack, Text, xcss } from '@atlaskit/primitives';

import quoteCard1Img from './_assets/quote-card-1.png';
import quoteCard2Img from './_assets/quote-card-2.png';
import quoteCard3Img from './_assets/quote-card-3.png';

type QuoteCardProps = {
	card: {
		content: string;
		author: string;
		image: any;
	};
	isInverted?: boolean;
};

const containerStyles = xcss({
	borderRadius: '12px',
	backgroundColor: 'elevation.surface.sunken',
	width: '100%',
	overflow: 'hidden',
});

const invertedStyles = xcss({
	flexDirection: 'row-reverse',
});

const imageStyles = xcss({
	width: '50%',
});

const textContainerStyles = xcss({
	padding: 'space.400',
	width: '50%',
});

export const quoteCard1 = {
	content:
		'“I regularly use the Atlassian Design System guidance to create consistent, high-quality, and accessible content at speed. The design system standards form the foundation for guidelines in our Jira UI kit and pattern library.”',
	author: 'Lead Content Designer, Jira',
	image: quoteCard1Img,
};

export const quoteCard2 = {
	content:
		'“The design system streamlines development, with built-in best practices. Consistent implementation across apps means that we can eliminate learning curves between components.”',
	author: 'Principal Software Engineer, Compass',
	image: quoteCard2Img,
};

export const quoteCard3 = {
	content: `“Our design system helps us create cohesive user experiences. Every design choice is made intentionally, and the system's consistent building blocks help us to create connected solutions.”`,
	author: 'Lead Visualisation Designer, Jira',
	image: quoteCard3Img,
};

// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Quote card__
 *
 * A quote card {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export const QuoteCard = ({ card, isInverted }: QuoteCardProps) => {
	return (
		<Inline
			xcss={[containerStyles, isInverted && invertedStyles]}
			alignBlock="center"
			alignInline="center"
		>
			<Box xcss={imageStyles}>
				<Image src={card.image} alt="" />
			</Box>
			<Stack space="space.200" xcss={textContainerStyles}>
				<Text>{card.content}</Text>
				<Text weight="bold">{card.author}</Text>
			</Stack>
		</Inline>
	);
};
